import { render } from "./FileContentsIndex.vue?vue&type=template&id=0b6e6ece&scoped=true&ts=true"
import script from "./FileContentsIndex.vue?vue&type=script&lang=ts"
export * from "./FileContentsIndex.vue?vue&type=script&lang=ts"

import "./FileContentsIndex.vue?vue&type=style&index=0&id=0b6e6ece&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6e6ece"]])

export default __exports__